export enum UserType {
  TEACHER = 'teacher',
  STUDENT = 'student',
  SCHOOL_ADMIN = 'SCHOOL_ADMIN',
  DISTRICT_ADMIN = 'DISTRICT_ADMIN'
}